import { HTTPRequestMethod } from 'lib-shared-legacy-types';
import { ajaxSend } from 'api/api';
const base = '/v1/flows';
export function addFlow(payload) {
    return ajaxSend({
        method: HTTPRequestMethod.Post,
        path: base,
        data: payload.flow,
    });
}
export function getFlow(payload) {
    return ajaxSend({
        path: `${base}/${payload.id}`,
    });
}
export function updateFlow(payload) {
    return ajaxSend({
        method: HTTPRequestMethod.Put,
        path: `${base}/${payload.id}`,
        data: payload.flow,
    });
}
